(function () {
    'use strict';

    angular
        .module('app')
        .controller('TicketsController', TicketsController);

    TicketsController.$inject = ['$http', '$rootScope', '$state', '$cookies', '$scope', '$filter', 'authenticator', '$stateParams', 'emojiReplacer', 'cache'];

    function TicketsController($http, $rootScope, $state, $cookies, $scope, $filter, authenticator, $stateParams, emojiReplacer, cache) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;

        var vm = this;
        vm.goToTab = goToTab;
        vm.showTicket = showTicket;
        vm.hideTicket = hideTicket;

        vm.$onInit = function () {
            vm.tab = $stateParams.tab;
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            Promise.all([getTickets()]).then(function () {
            });
        }

        function getTickets() {
            if (cache.exists('upcoming_tickets') && cache.exists('past_tickets')) {
                vm.upcoming_tickets = cache.load('upcoming_tickets');
                vm.past_tickets = cache.load('past_tickets');
                return Promise.resolve();
            } else {
                $http.get('api/usertickets/all')
                .then(function(response){
                    vm.upcoming_tickets = response.data.upcoming ? response.data.upcoming : [];
                    vm.past_tickets = response.data.past ? response.data.past : [];
                    cache.save('upcoming_tickets', vm.upcoming_tickets);
                    cache.save('past_tickets', vm.past_tickets);
                });
            }
        }

        function goToTab(tab){
            vm.tab = tab;
            var scrollY = window.scrollY;
            $state.transitionTo('tickets', {tab: tab}, {
                location: true, // This makes it update URL
                inherit: true,
                relative: $state.$current,
                notify: false // This makes it not reload
            }).then(function () {
                window.scrollTo(0, scrollY);
            });
        }

        function showTicket(ticket){
            vm.selected_ticket = ticket;
            vm.selected_ticket.map_link = "https://www.google.com/maps/place/" + vm.selected_ticket.concert_address + ",+" + vm.selected_ticket.concert_zip + "+" + vm.selected_ticket.concert_city + "/";
            vm.show_ticket = true;
            // $rootScope.no_scroll = true;
            disableScrolling();
        }

        function hideTicket(){
            vm.show_ticket = false;
            $rootScope.no_scroll = false;
            enableScrolling();
        }

        function disableScrolling(){
            var x=window.scrollX;
            var y=window.scrollY;
            window.onscroll=function(){window.scrollTo(x, y);};
        }

        function enableScrolling(){
            window.onscroll=function(){};
        }
    }
})();
